import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = createStateReducer(initialState, {
  [events.editPreferencesRequested]: setRequestStateToPending,
  [events.editPreferencesSucceeded]: setRequestStateToSuccess,
  [events.editPreferencesFailed]: setRequestStateToFailure,
});

function createSelector(getState: () => State): Selector {
  return {
    isEditPreferencesRequestFailure() {
      return getState().isFailure;
    },
    isEditPreferencesRequestPending() {
      return getState().isPending;
    },
    isEditPreferencesRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
